import styled from 'styled-components';

export const Logo = styled.img`
  width: 100px;
`;
